var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.967 140.796C150.967 145.895 117.161 150.026 75.4837 150.026C33.8069 150 0 145.895 0 140.796C0 135.698 33.8069 131.567 75.4837 131.567C117.161 131.567 150.967 135.698 150.967 140.796Z",
    fill: "#1E01BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4342 13.3975L20.2021 85.688L61.5651 96.6922L80.7972 24.4017L39.4342 13.3975Z",
    fill: "#F05A3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8537 0.0256765L21.4291 63.9023L56.3077 88.7056L101.732 24.8289L66.8537 0.0256765Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9723 139.725L141.816 90.2302C145.032 88.3476 146.13 84.2166 144.248 80.9744L107.8 18.4853C105.918 15.2694 101.787 14.1712 98.5445 16.0538L13.7005 65.5483C10.4846 67.4308 9.38644 71.5619 11.269 74.804L47.7166 137.293C49.5991 140.509 53.7302 141.607 56.9723 139.725Z",
    fill: "#FF8C69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.303 71.6141C108.245 71.1173 120.769 64.7638 131.175 62.3322L127.018 55.1943L107.303 71.6141Z",
    fill: "#F05A3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.248 80.9744L107.8 18.4853C105.918 15.2694 101.787 14.1712 98.5445 16.0538L98.2308 16.2368C98.2308 16.2368 126.233 71.2481 134.129 94.7011L141.816 90.204C145.032 88.3476 146.13 84.1904 144.248 80.9744Z",
    fill: "#F05A3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.826 71.3789L129.894 58.5151C131.515 57.5738 132.064 55.5083 131.123 53.8872L123.279 40.4481C122.337 38.8271 120.272 38.278 118.651 39.2193L96.5836 52.0831C94.9625 53.0244 94.4135 55.0899 95.3547 56.711L103.199 70.1501C104.14 71.7711 106.205 72.3202 107.826 71.3789Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.388 63.4306C108.67 63.4306 110.519 61.5811 110.519 59.2995C110.519 57.018 108.67 55.1685 106.388 55.1685C104.107 55.1685 102.257 57.018 102.257 59.2995C102.257 61.5811 104.107 63.4306 106.388 63.4306Z",
    fill: "#1E01BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.26188acdf4e232e81fc30cdab8a8f9c6.svg";
export { ForwardRef as ReactComponent };